export const DEFAULT_STORE_THEME = {
  primary: "#173B2F",
  accent: "#EA6A3B",
  background: "#FFFDF8",
  text: "#171717",
  headingFont: "Sora",
  bodyFont: "DM Sans",
  radius: 8,
  buttonStyle: "rounded",
};

function normalizeHex(value, fallback) {
  if (!value || typeof value !== "string") return fallback;
  const trimmed = value.trim();
  if (/^#[0-9A-Fa-f]{6}$/.test(trimmed)) return trimmed;
  if (/^#[0-9A-Fa-f]{3}$/.test(trimmed)) {
    return `#${trimmed[1]}${trimmed[1]}${trimmed[2]}${trimmed[2]}${trimmed[3]}${trimmed[3]}`;
  }
  return fallback;
}

/** Resolve published `theme_overrides` into colors, fonts, and CSS variables for the storefront. */
export function resolveStoreTheme(business = {}) {
  const overrides = business.theme_overrides || {};
  const primary = normalizeHex(overrides.primary_color, DEFAULT_STORE_THEME.primary);
  const accent = normalizeHex(overrides.accent_color, DEFAULT_STORE_THEME.accent);
  const background = normalizeHex(overrides.background, DEFAULT_STORE_THEME.background);
  const text = normalizeHex(overrides.text, DEFAULT_STORE_THEME.text);
  const headingFont = overrides.heading_font || DEFAULT_STORE_THEME.headingFont;
  const bodyFont = overrides.body_font || DEFAULT_STORE_THEME.bodyFont;
  const radius = Number(overrides.corner_radius) || DEFAULT_STORE_THEME.radius;
  const buttonStyle = overrides.button_style || DEFAULT_STORE_THEME.buttonStyle;
  const buttonRadius = buttonStyle === "sharp" ? 4 : buttonStyle === "pill" ? 999 : radius;

  return {
    primary,
    accent,
    background,
    text,
    headingFont,
    bodyFont,
    radius,
    buttonRadius,
    buttonStyle,
    cssVars: {
      "--store-primary": primary,
      "--store-accent": accent,
      "--store-bg": background,
      "--store-text": text,
      "--store-muted": `color-mix(in srgb, ${primary} 10%, ${background})`,
      /* Slightly darker than page bg so cards/chips read on white themes (~#F5F5F5 on #fff). */
      "--store-card": `color-mix(in srgb, #000000 4.5%, ${background})`,
      "--store-soft": `color-mix(in srgb, ${primary} 16%, white)`,
      "--store-radius": `${radius}px`,
      "--store-btn-radius": `${buttonRadius}px`,
      "--store-heading-font": `"${headingFont}", "Sora", "DM Sans", sans-serif`,
      "--store-body-font": `"${bodyFont}", "DM Sans", sans-serif`,
      color: text,
      backgroundColor: background,
      fontFamily: `"${bodyFont}", "DM Sans", sans-serif`,
    },
  };
}
